//MaterialUI
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

export default function Appbar() {
  // const logoUrl =
  //   "http://coopasv.com/wp-content/uploads/2017/05/footer-logo.png";
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar variant="dense">
          <Box
            sx={{
              position: "absolute",
              left: 50,
              right: 50,
            }}
          >
            <Typography
              variant="h6"
              color="inherit"
              aria-label="Organization_Name"
              align="center"
              noWrap
            >
              COOPASV
            </Typography>
            {/* <img src={logoUrl} alt="company-Logo" width={100} height="auto" /> */}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
